// extracted by mini-css-extract-plugin
export default {"header":"CollegeAdminHome_header__eqwve","notVerified":"CollegeAdminHome_notVerified__s0Uul"};